import "firebase/auth";
import fire from "./config"; 
import "firebase/firestore";


const db = fire.firestore(); 

export default db; 